export function attachSoftwareLandscapeSheetScroll(root, isSoftwareLandscape) {
  let gesture = null
  const updateRange = (range, touch) => {
    const rect = range.getBoundingClientRect()
    const min = Number(range.min) || 0
    const max = range.max === '' ? 100 : Number(range.max)
    const step = range.step === 'any' ? 0 : Number(range.step) || 1
    const ratio = Math.max(0, Math.min(1, (touch.clientY - rect.top) / Math.max(1, rect.height)))
    const raw = min + ratio * (max - min)
    const value = Math.max(min, Math.min(max, step ? min + Math.round((raw - min) / step) * step : raw))
    if (Number(range.value) === value) return
    range.value = String(Number(value.toFixed(10)))
    range.dispatchEvent(new Event('input', { bubbles: true }))
  }
  const start = event => {
    gesture = null
    if (!isSoftwareLandscape() || event.touches.length !== 1) return
    const target = event.target
    const touchSurface = target.closest?.('.sheet.is-open') || target.closest?.('.video-recording-dialog')
    if (!touchSurface) return
    const touch = event.touches[0]
    if (target.matches?.('input[type="range"]') && !target.disabled) {
      if (event.cancelable) event.preventDefault()
      gesture = { id: touch.identifier, range: target }
      updateRange(target, touch)
      return
    }
    if (target.closest('input,textarea,select,video,audio')) return
    gesture = { id: touch.identifier, target, x: touch.clientX, y: touch.clientY, scrolling: false }
  }
  const move = event => {
    if (!gesture || !isSoftwareLandscape() || event.touches.length !== 1) {
      gesture = null
      return
    }
    const touch = Array.from(event.touches).find(item => item.identifier === gesture.id)
    if (!touch) return
    if (gesture.range) {
      if (event.cancelable) event.preventDefault()
      updateRange(gesture.range, touch)
      return
    }
    // rotate(90deg) maps local horizontal to screen Y and local vertical to -X.
    const dx = gesture.y - touch.clientY
    const dy = touch.clientX - gesture.x
    if (!gesture.scrolling && Math.hypot(dx, dy) < 6) return
    const horizontal = Math.abs(dx) > Math.abs(dy)
    for (let element = gesture.target; element && element !== root; element = element.parentElement) {
      const style = getComputedStyle(element)
      const overflow = horizontal ? style.overflowX : style.overflowY
      const extent = horizontal ? element.scrollWidth - element.clientWidth : element.scrollHeight - element.clientHeight
      if (!/^(auto|scroll)$/.test(overflow) || extent <= 1) continue
      if (event.cancelable) event.preventDefault()
      if (horizontal) element.scrollLeft += dx
      else element.scrollTop += dy
      gesture.scrolling = true
      gesture.x = touch.clientX
      gesture.y = touch.clientY
      break
    }
  }
  const end = () => {
    gesture?.range?.dispatchEvent(new Event('change', { bubbles: true }))
    gesture = null
  }
  const cancel = () => { gesture = null }
  root.addEventListener('touchstart', start, { passive: false })
  root.addEventListener('touchmove', move, { passive: false })
  root.addEventListener('touchend', end, { passive: true })
  root.addEventListener('touchcancel', cancel, { passive: true })
  return () => {
    root.removeEventListener('touchstart', start)
    root.removeEventListener('touchmove', move)
    root.removeEventListener('touchend', end)
    root.removeEventListener('touchcancel', cancel)
    gesture = null
  }
}
